import { useMutation, useQueryClient } from "@tanstack/react-query";
import { copySurveyToProject, CopySurveyToProjectParams } from ".";

export function useCopySurveyToProject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['survey', 'project', 'copy'],
        mutationFn: async (props: CopySurveyToProjectParams) => {
            try {
                const res = await copySurveyToProject(props)
                return res;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: ['project'],
                exact: false
            });
            queryClient.invalidateQueries({
                queryKey: ['survey'],
                exact: false
            });
        }
    })
}